import { Spine } from '@leprecoins/react-pixi';
import { Container } from '@pixi/react';
import { useUnit } from 'effector-react';
import { interactiveElementModel } from '../../model';

export const InteractiveElementGoalkeeper = () => {
	const [spine, shift] = useUnit([
		interactiveElementModel.goalkeeperSpine.$spine,
		interactiveElementModel.$goalkeeperShift,
	]);

	return (
		<Container
			x={shift}
			anchor={0.5}
		>
			<Spine spine={spine} />
		</Container>
	);
};
